import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { mergeStyles } from "@fluentui/react";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider, createTheme } from "@fluentui/react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import "./i18n";

// Pages
import DeltaMesh from "./pages/DeltaMesh"; // U
import About from "./pages/About"; // U
import Products from "./pages/Products"; // U
import Pricing from "./pages/Pricing"; // U

import { initializeIcons } from "@fluentui/react";
initializeIcons();

// Inject some global styles
mergeStyles({
  ":global(body,html,#root)": {
    margin: 0,
    padding: 0,
    height: "100vh",
  },
});

const myTheme = createTheme({
  palette: {
    themePrimary: "#0078d4", // Microsoft's blue color
    neutralPrimary: "#333",
    // Add more color customizations as needed
  },
});

ReactDOM.render(
  <ThemeProvider theme={myTheme}>
    <Router>
      <Routes>
        {/* Define a parameterized route for locale */}
        <Route path="/:locale" element={<App />} />
        <Route path="/:locale/delta-mesh" element={<DeltaMesh />} />
        <Route path="/:locale/about-us" element={<About />} />
        <Route path="/:locale/products" element={<Products />} />
        <Route path="/:locale/pricing" element={<Pricing />} />
        {/* Redirect to English if no matching route is found */}
        <Route path="*" element={<Navigate to="/en-us" />} />
      </Routes>
    </Router>
  </ThemeProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
